<template>
  <div class="flex flex-row-between user-wrap flex-items-start">
    <div class="user-left">
      <router-link
        class="flex flex-row-between user-left-box"
        tag="a"
        to="/user/basic"
        :class="{ active: userActiveMenu === '/user/basic' }"
      >
        <i class="el-icon-s-custom"></i>
        <p>个人中心</p>
        <i class="el-icon-caret-right"></i>
      </router-link>
      <router-link
        class="flex flex-row-between user-left-box"
        tag="a"
        to="/user/myfeedback"
        :class="{ active: userActiveMenu === '/user/myfeedback' }"
      >
        <i class="el-icon-news"></i>
        <p>用户反馈</p>
        <i class="el-icon-caret-right"></i>
      </router-link>
      <router-link
        class="flex flex-row-between user-left-box"
        tag="a"
        to="/user/myPromise"
        :class="{ active: userActiveMenu === '/user/myPromise' }"
      >
        <i class="el-icon-s-custom"></i>
        <p>政务承诺</p>
        <i class="el-icon-caret-right"></i>
      </router-link>
      <router-link
        class="flex flex-row-between user-left-box"
        tag="a"
        to="/user/myappeal"
        :class="{ active: userActiveMenu === '/user/myappeal' }"
      >
        <i class="el-icon-s-custom"></i>
        <p>异议申诉</p>
        <i class="el-icon-caret-right"></i>
      </router-link>
      <router-link
        class="flex flex-row-between user-left-box"
        tag="a"
        to="/user/myRepair"
        :class="{ active: userActiveMenu === '/user/myRepair' }"
      >
        <i class="el-icon-s-custom"></i>
        <p>信用修复</p>
        <i class="el-icon-caret-right"></i>
      </router-link>
      <router-link
        class="flex flex-row-between user-left-box"
        tag="a"
        to="/user/historical-declaration"
        :class="{ active: userActiveMenu === '/user/historical-declaration' }"
      >
        <i class="el-icon-s-custom"></i>
        <p>历史申报</p>
        <i class="el-icon-caret-right"></i>
      </router-link>
    </div>
    <div class="user-right">
      <router-view @userEmit="userEmit"></router-view>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      userActiveMenu: "/user/basic",
    };
  },
  created() {},
  mounted() {},
  methods: {
    userEmit(data) {
      console.log(data);
      this.$set(this, "userActiveMenu", data);
    },
  },
  computed: {},
  watch: {},
};
</script>
<style lang="scss" scoped>
.user-wrap {
  width: 1280px;
  min-height: calc(100vh - 400px);
  background: #fbfbfb;
  overflow: hidden;
  padding-bottom: 10px;
  margin: 0 auto;
  padding: 50px 0;
  & > .user-left {
    width: 137px;
    height: 232px;
    & > .user-left-box {
      padding: 0 8px 0 16px;
      height: 58px;
      line-height: 58px;
      color: #555;
      background: #f5f3f4;
      border-bottom: 1px solid #cfcfcf;
      border-left: 4px solid transparent;
      &.active,
      &:hover {
        background-color: $red;
        color: #fff;
      }
    }
  }
  & > .user-right {
    padding: 0 50px 0 20px;
    min-height: 500px;
    width: 1143px;
    background: #fff;
  }
}
</style>
